import Cookies from 'js-cookie';
import { getInstanceById } from '@rynpsc/dialog';

let testMode = false;
let instanceId = 'exit-modal';

export function init() {
	if (Cookies.get(instanceId) && !testMode) {
		return;
	}

	setTimeout(function trackMouse() {
		document.addEventListener('mouseout', onMouseout);
	}, !testMode ? 60000 : 0);
}

function onMouseout(event) {
	let { toElement, relatedTarget, clientY } = event;

	let modal = getInstanceById(instanceId);
	let isExiting = !toElement && !relatedTarget && clientY < 10;

	if (!isExiting || !modal) {
		return;
	}

	modal.open();

	if (testMode) {
		return;
	}

	// Set a cookie to prevent showing again for x days.
	Cookies.set(instanceId, 'true', {
		expires: 7,
		sameSite: 'strict',
	});

	document.removeEventListener('mouseout', onMouseout);
}
